import * as fs from "fs";
import { Prize } from "@crunchdao/sdk";

function validatePrize(prize: any): prize is Prize {
  return (
    typeof prize.timestamp === "number" &&
    typeof prize.model === "string" &&
    typeof prize.prize === "number"
    // prizeId is optional, so we don't validate it
  );
}

function getMissingFields(prize: any): string[] {
  const missing: string[] = [];

  if (typeof prize.timestamp !== "number") missing.push("timestamp (number)");
  if (typeof prize.model !== "string") missing.push("model (string)");
  if (typeof prize.prize !== "number") missing.push("prize (number)");
  // prizeId is optional, so we don't validate it

  return missing;
}

export function readPrizeJsonFile(prizeFileName: string): Prize[] {
  const prizeFile = fs.readFileSync(prizeFileName, "utf8");
  const prizes: Prize[] = [];
  const lines = prizeFile.split("\n").filter((line) => line.trim() !== "");

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    let prize;

    try {
      prize = JSON.parse(line);
    } catch {
      throw new Error(`Invalid JSON at line ${i + 1}: ${line}`);
    }

    if (!validatePrize(prize)) {
      const missingFields = getMissingFields(prize);
      throw new Error(
        `Invalid prize format at line ${i + 1}. Missing or invalid fields: ${missingFields.join(
          ", "
        )}. Line content: ${line}`
      );
    }

    prizes.push(prize);
  }
  return prizes;
}
